__turbopack_context__.v({
  "gift-hero": "GiftHero-module-scss-module__TTKvqq__gift-hero",
  "gift-hero__band": "GiftHero-module-scss-module__TTKvqq__gift-hero__band",
  "gift-hero__content": "GiftHero-module-scss-module__TTKvqq__gift-hero__content",
  "gift-hero__copy": "GiftHero-module-scss-module__TTKvqq__gift-hero__copy",
  "gift-hero__headline": "GiftHero-module-scss-module__TTKvqq__gift-hero__headline",
  "gift-hero__image": "GiftHero-module-scss-module__TTKvqq__gift-hero__image",
  "gift-hero__mobile": "GiftHero-module-scss-module__TTKvqq__gift-hero__mobile",
  "gift-hero__side": "GiftHero-module-scss-module__TTKvqq__gift-hero__side",
  "gift-hero__side--left": "GiftHero-module-scss-module__TTKvqq__gift-hero__side--left",
  "gift-hero__side--right": "GiftHero-module-scss-module__TTKvqq__gift-hero__side--right",
});
